import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Icon, iconRadar } from '@ns/plugin-ns-theme';

const techRadarRouteRef = createRouteRef();

export const listPage = PageBlueprint.make({
  name: 'index',
  params: {
    icon: <Icon glyph={iconRadar} />,
    loader: () =>
      import('./components/tech-radar-list-page/tech-radar-list-page').then(
        m => <m.TechRadarListPage />,
      ),
    path: '/tech-radars',
    routeRef: techRadarRouteRef,
    title: 'Tech radars',
  },
});

const nsTechRadarPlugin = createFrontendPlugin({
  extensions: [listPage],
  pluginId: 'ns-tech-radar',
  routes: { root: techRadarRouteRef },
});

export default nsTechRadarPlugin;

// Columns
export { techRadarColumns } from './columns';

// Components
export {
  QuadrantListCard,
  type QuadrantListCardProps,
} from './components/quadrant-list-card';
export {
  TechRadarDetailPage,
  TechRadarDetailPageContent,
} from './components/tech-radar-detail-page';
export { TechRadarEntityOverviewContent } from './components/tech-radar-entity-overview-content';
export { TechRadarFilters } from './components/tech-radar-filters';
export { TechRadarListPage } from './components/tech-radar-list-page';

// Types
export type { QuadrantGroups } from './lib/group-entries';
